import React from "react";
import { StyledButton } from "../helpers/button";
import "../services/services.css";
import "./portfolioCarousel.css";
import SafariAdmin from "../images/safariAdminCustomers.PNG";
const Portfolio = ({ title, desc, content, image }) => {
  return (
    <>
      <section className={"carouselitem"}>
        <div className={"carouselImage"}>
          <img alt="img1" src={image} />
        </div>
        <div className={"carouselText"}>
          <div className={"serviceDetailContainer"}>
            <div class="serviceDetails">
              <h3>{title}</h3>
              <p>{desc}</p>
              <ul>
                {content.map((item) => (
                  <li>{item}</li>
                ))}
                {/* <li>UI UX Design</li>
                <li>Web Design</li>
                <li>Web Development</li>
                <li>Mobile App Development</li>
                <li>Hybrid App Development</li>
                <li>Some more</li> */}
              </ul>
              <StyledButton height={"45px"}>Get A Deal Now</StyledButton>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Portfolio;
